import { Component, Input, ViewEncapsulation } from '@angular/core';

export enum Type {
  PERCENTAGE = 'percentage',
  STEPS = 'step'
}

@Component({
  selector: 'vfs-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProgressBarComponent {
  types = Type;
  @Input() type: Type;
  @Input() width = '100%';
  @Input() color = 'accent';
  @Input() mode = 'indeterminate';
  @Input() value: number;
  @Input() maxValue = 100;
  @Input() small = false;

  /**
   * @returns Return progress bar value.
   */
  getValue(): number {
    return (100 * Math.min(Math.max(this.value, 0), this.maxValue)) / this.maxValue;
  }

  /**
   * @returns Return progress bar value to show and depend if it is percentage or step
   */
  getShownValue(): number {
    return this.type === this.types.PERCENTAGE
      ? (100 * Math.min(Math.max(this.value, 0), this.maxValue)) / this.maxValue
      : Math.min(Math.max(this.value, 0), this.maxValue);
  }
}
